type Config =
  | {
      digits?: number;
      calculate?: boolean;
    }
  | undefined;

export function formatCurrency(amount: number, currency: string, config: Config = undefined): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: config?.digits ? config.digits : 0,
    maximumFractionDigits: config?.digits ? config.digits : 0,
  }).format(config?.calculate ? amount / 100 : amount);
}
